import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/shared/services/auth.service";

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit {
  public userName: string = '';
  public userInitials: string = '';
  public userRole: string = 'Admin';
  public profileImg: string = "assets/images/dashboard/profile.jpg";
  public isDropdownOpen: boolean = false;

  constructor(public router: Router, private authService: AuthService) {}

  ngOnInit() {
    this.loadUserInfo();
  }

  loadUserInfo() {
    // Try to get user from sessionStorage first, then localStorage
    const userStr = sessionStorage.getItem('user') || localStorage.getItem('user');
    const username = sessionStorage.getItem('username') || localStorage.getItem('username');

    if (username) {
      this.userName = username;
    } else if (userStr) {
      try {
        const user = JSON.parse(userStr);
        this.userName = user?.data?.userName || user?.userName || 'User';
      } catch (error) {
        console.error('Error parsing user data:', error);
        this.userName = 'User';
      }
    } else {
      this.userName = 'User';
    }

    // Generate initials from userName
    this.userInitials = this.generateInitials(this.userName);
  }

  generateInitials(name: string): string {
    if (!name) return 'U';

    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }

  logoutFunc() {
    this.closeDropdown();
    this.authService.doLogout();
  }

  navigateTo(route: string) {
    this.closeDropdown();
    this.router.navigate([route]);
  }
}
